"use strict";

exports.__esModule = true;
var _AlertRoutes = require("./AlertRoutes");
Object.keys(_AlertRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertRoutes[key]) return;
  exports[key] = _AlertRoutes[key];
});